import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export function nonNullFilter<T>(): (
  source: Observable<T>,
) => Observable<NonNullable<T>> {
  return (source: Observable<T>) => {
    const stream = source.pipe(
      filter(v => v !== null),
      map(v => {
        if (v === null) {
          throw new Error('Value is null');
        }
        return v;
      }),
    );
    return stream as Observable<NonNullable<T>>;
  };
}
